angular.module('env.data.repos.categories', [])

    .service("categoriesRepository", function (rest) {
        var _this = this;
        var categoryTypeModel = "CategoryTypeModel";
        var categoryModel = "CategoryModel";
        var orderItemModel = "OrderItemModel";
        var categoryTypeDefinition = rest.getDefinition(categoryTypeModel);
        var categoryDefinition = rest.getDefinition(categoryModel);

        /**
         * Get Category by id
         * @param {!string|!number} id id of the Category
         * @returns {!Promise.<RepresentationModel>} promise of Category
         */
        _this.getCategory = function (id) {
            return rest
                .map(categoryDefinition)
                .map(id)
                .willReturn(categoryModel, id)
                .get();
        };

        /**
         * Get OrderItems for Category
         * @param {!string} id id of the Category
         * @returns {!Promise.<RepresentationModel[]>} promise of OrderItems collection
         */
        _this.getOrderItemsForCategory = function (id) {
            return rest
                .map(categoryDefinition)
                .map(id)
                .map("orderitems")
                .willReturn(orderItemModel)
                .get();
        };

        /**
         * Get Categories by id
         * @param {!string[]|!number[]} ids Category id's collection
         * @returns {!Promise.<RepresentationModel[]>} promise of Category collection
         */
        _this.getCategoriesByIds = function (ids) {
            return rest
                .map(categoryDefinition)
                .willReturn(categoryModel)
                .get({params: { ids: ids.join(',') }});
        };

        /**
         * Get Categories by CategoryType code
         * @param {!string} categoryTypeCode CategoryType code
         * @returns {!Promise.<RepresentationModel[]>} promise of Category collection
         */
        _this.getCategoriesByTypeCode = function (categoryTypeCode) {
            return rest
                .map(categoryDefinition)
                .willReturn(categoryModel)
                .get({params: { typeCode: categoryTypeCode }});
        };

        /**
         * Get Categories by CategoryType codes
         * @param {!string[]} categoryTypeCodes CategoryType codes collection
         * @returns {!Promise.<RepresentationModel[]>} promise of Category collection
         */
        _this.getCategoriesByTypeCodes = function (categoryTypeCodes) {
            return rest
                .map(categoryDefinition)
                .willReturn(categoryModel)
                .get({ params: { typeCodes: categoryTypeCodes.join(',') } });
        };

        /**
         * Link OrderItems to category
         * @param {!string|!number} categoryId id of Category
         * @param {!string|!number} orderItemIds collection of OrderItem ids
         * @returns {!Promise} promise of operation result
         */
        _this.linkOrderItemsToCategory = function (categoryId, orderItemIds) {
            return rest
                .map(categoryDefinition)
                .map(categoryId)
                .map("link")
                .post({orderItemIds: orderItemIds});
        };

        /**
         * Unlink OrderItems from category
         * @param {!string|!number} categoryId id of Category
         * @param {!string|!number} orderItemIds collection of OrderItem ids
         * @returns {!Promise} promise of operation result
         */
        _this.unlinkOrderItemsFromCategory = function (categoryId, orderItemIds) {
            return rest
                .map(categoryDefinition)
                .map(categoryId)
                .map("unlink")
                .post({orderItemIds: orderItemIds});
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("CategoryModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;